import { render, staticRenderFns } from "./home3.vue?vue&type=template&id=66b5b284&scoped=true&"
import script from "./home3.vue?vue&type=script&lang=js&"
export * from "./home3.vue?vue&type=script&lang=js&"
import style0 from "./home3.vue?vue&type=style&index=0&id=66b5b284&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b5b284",
  null
  
)

export default component.exports